import React from "react";

export interface IContent {
  heading: string;
  type: "paragraph" | "list" | "faq";
  list?: string[];
  paragraph?: string;
  children?: IContent[];
  faq?: { question: string; answer: string }[];
}

interface IProps {
  image: string;
  title: string;
  content: IContent[];
}

const Content = ({ content }: { content: IContent }) => {
  return (
    <div>
      <h2 className="font-Lexend-Regular font-size-20px theme-color-green leading-none mb-2 lg:mb-[0.5vw]">
        {content.heading}
      </h2>
      {content.type === "paragraph" && (
        <p className="font-Poppins-Regular font-size-18px text-[#707070]">
          {content.paragraph}
        </p>
      )}
      {content.type === "list" && (
        <div className="font-Poppins-Regular font-size-18px text-[#707070]">
          {content.list?.map((item, index) => (
            <div key={index} className="flex items-start">
              <span className="w-1.5 lg:w-[0.5vw] aspect-square mt-1.5 lg:mt-[0.4vw] mr-1.5 lg:mr-[0.5vw] rounded-full bg-gradient-to-b from-[#004540] to-[#00A297] flex-shrink-0"></span>
              <p key={index}>{item}</p>
            </div>
          ))}
        </div>
      )}
      {content.type === "faq" && (
        <div className="font-Poppins-Regular font-size-18px text-[#707070]">
          {content.faq?.map((item, index) => (
            <div key={index} className="flex items-start">
              <span className="w-1.5 lg:w-[0.5vw] aspect-square mt-1.5 lg:mt-[0.5vw] mr-1.5 lg:mr-[0.5vw] rounded-full bg-gradient-to-b from-[#004540] to-[#00A297] flex-shrink-0"></span>
              <p key={index}>{item.question}</p>
            </div>
          ))}
        </div>
      )}
      {content.children &&
        content.children.map((item, index) => (
          <Content key={index} content={item} />
        ))}
    </div>
  );
};

const TermsPrivacyDetails = ({ image, title, content }: IProps) => {
  return (
    <div className="view-area-width box-design my-4 p-3 lg:p-[1vw] flex flex-col gap-3 lg:gap-[1.4vw]">
      {image && (
        <div className="flex items-center justify-center mb-1 lg:mb-[0.5vw]">
          <img src={image} alt={title} className="w-full h-full object-cover rounded-md lg:rounded-[0.5vw] shadow-md" />
        </div>
      )}
      <h1 className="font-Lexend-Bold font-size-40px theme-color-green leading-none">
        {title}
      </h1>
      <div className="flex flex-col gap-3 lg:gap-[1.4vw]">
        {content.map((item, index) => (
          <Content key={index} content={item} />
        ))}
      </div>
    </div>
  );
};

export default TermsPrivacyDetails;
